import { useEffect, useState } from "react";
import { Statistic, Card, Spin, Row, Col, Space, Tag, Divider, Typography, Button } from 'antd';
import styles from './index.module.scss'
import { getVideoCount, getTemplateCount } from "../../api/statistic";
import { AxiosResponse } from 'axios';
import type { VideoCount } from "../../types/statistic";
import { useNavigate } from "react-router-dom";
import {
  UserOutlined,
  CheckCircleOutlined,
  BulbOutlined,
  CrownOutlined,
  ThunderboltOutlined,
  RocketOutlined
} from '@ant-design/icons';
import { getUserProfile } from '../../api/user';
import type { UserInfo } from '../../types/user';
import WeCom from '../../assets/images/wecom.jpg';
import ImageDisplayModal from "../components/ImageDisplayModal";
import type { SubscriptionMap, PlanStyle } from '../../types/home';
import { useTranslation } from "react-i18next";

const { Title, Text } = Typography;


const Home = () => {

  useEffect(() => {
    handleVideoCount()
    handleTemplateCount()
    fetchUserInfo()
  }, [])

  const [videoCount, setVideoCount] = useState<VideoCount | null>(null)
  const [templateCount, setTemplateCount] = useState<VideoCount | null>(null)
  const [loadings, setLoadings] = useState<boolean[]>([false, false, false, false])
  const [currentUserInfo, setCurrentUserInfo] = useState<UserInfo | null>(null)
  const [isWeComVisible, setIsWeComVisible] = useState<boolean>(false)

  const navigate = useNavigate()
  const { t } = useTranslation();

  const subscriptionMap: SubscriptionMap = {
    '1': { color: 'default', icon: <BulbOutlined /> },
    '2': { color: 'blue', icon: <RocketOutlined /> },
    '3': { color: 'gold', icon: <CrownOutlined /> },
    '4': { color: 'purple', icon: <ThunderboltOutlined /> }
  };
  const defaultPlanStyle: PlanStyle = subscriptionMap['1']
  const planStyle = currentUserInfo? subscriptionMap[currentUserInfo.planId.toString()] || defaultPlanStyle: defaultPlanStyle;


  const handleVideoCount = () => {
    enterLoading(2)
    getVideoCount().then((res: AxiosResponse) => {
      if (res.data.status === 200) {
        setVideoCount(res.data.data)

      }
      enterLoading(2, false)
    }).catch(() => {
      enterLoading(2, false)
    })
  }

  const handleTemplateCount = () => {
    enterLoading(1)
    getTemplateCount().then((res: AxiosResponse) => {
      if (res.data.status === 200) {
        setTemplateCount(res.data.data)
      }
      enterLoading(1, false)
    }).catch(() => {
      enterLoading(1, false)
    })
  }

  const enterLoading = (index: number, status: boolean = true) => {

    setLoadings((prevLoadings) => {
      const newLoadings = [...prevLoadings];
      newLoadings[index] = status;
      return newLoadings;
    });
  }


  const fetchUserInfo = () => {
    enterLoading(3)
    getUserProfile().then((res: AxiosResponse) => {
      if (res.data.status === 200) {
        setCurrentUserInfo(res.data.data)
      }
      enterLoading(3, false)
    }).catch(() => {
      enterLoading(3, false)
    })
  }
  


  return (
    <>
      <div className={styles.section}>
        <div className={styles.sectionHeader}>
          <div className={styles.title}>{t('home.title1')}</div>
        </div>
        <Row>
          <Col xs={24} lg={16}>
            <div className={styles.mainGrid}>
              <Spin spinning={loadings[1]} >
                <Card hoverable className={styles.stardCard} onClick={() => navigate('/console/clone/template')}>
                  <Statistic title={t('home.templates')} value={templateCount ? templateCount['total'] : 0} />
                  <text className={styles.percent}>
                    {templateCount && `${templateCount?.['2'] ?? 0}/${templateCount?.total} ${t('home.finished')}`}
                  </text>

                </Card>
              </Spin>
              <Spin spinning={loadings[2]}>
                <Card className={styles.stardCard} hoverable onClick={() => navigate('/console/video')}>
                  <Statistic title={t('home.videos')} value={videoCount ? videoCount['total'] : 0} />
                  <text className={styles.percent}>
                    {videoCount && `${videoCount?.['2'] ?? 0}/${videoCount?.total} ${t('home.finished')}`}
                  </text>
                </Card>
              </Spin>
              <Spin spinning={loadings[2]}>
                <Card className={styles.noCursorCard} hoverable>
                  <Statistic title={t('home.gen_today')} value={videoCount ? videoCount.daily : 0} />

                </Card>
              </Spin>
              <Spin spinning={loadings[2]}>
                <Card className={styles.noCursorCard} hoverable>
                  <Statistic title={t('home.gen_month')} value={videoCount ? videoCount.monthly : 0} />

                </Card>
              </Spin>


            </div>
          </Col>
          <Col xs={24} lg={8}>
            <Spin spinning={loadings[3]}>
              <Card className={styles.userInfoCard} hoverable>
                <div className={styles.userProfile}>
                  <div className={styles.userDetails}>
                    <Title level={1} className={styles.userName}>{currentUserInfo?.nickname}</Title>
                    <div className={styles.subscriptionBadge}>
                      <Tag color={planStyle.color} icon={planStyle.icon}>
                        {currentUserInfo?.planName}
                      </Tag>

                    </div>
                  </div>
                </div>
                <Divider />
                <div className={styles.userStats}>
                  <Text type="secondary">{t('home.exp_date')}：{currentUserInfo? currentUserInfo.subExpiresAt || t('home.permanent_mem'): t('home.permanent_mem')}</Text>
                  <Button
                    type="link"
                    size="small"
                    onClick={() => setIsWeComVisible(true)}
                    className={styles.upgradeBtn}
                  >

                    {t('home.upgrade_sub')}
                  </Button>
                </div>
              </Card>
            </Spin>

          </Col>
        </Row>
      </div>
      <ImageDisplayModal
        isVisible={isWeComVisible}
        onClose={() => setIsWeComVisible(false)}
        imageUrl={WeCom}
        imageAlt=""
        imageWidth={300}
        preview={false}
        title="扫码付费购买"
      />

    </>
  )
}


export default Home;

